import axios from 'axios';

let isAlerting = false;

const SERVER_URL = process.env.REACT_APP_SERVER_URL || "/hixLocal";

// 建立 axios instance
const _axios = axios.create({
  baseURL: SERVER_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 10000,
});

// Request interceptor
_axios.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    failed(error);
    return Promise.reject(error);
  }
);

// Response interceptor
_axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    failed(error)
    return Promise.reject(error);
  }
);

function failed (error) {
  const { response, code, message } = error;
  // 主動取消的請求不報錯
  if (code === 'ERR_CANCELED') return;
  if (!response) {
    console.error('Missing server connection:', error);
    if (code === 'ECONNABORTED') {
      return popApiError('TIMEOUT', '連線逾時，請檢查網路連線或稍後再試');
    }
    if (code === 'ERR_NETWORK' || message === 'Network Error') {
      return popApiError('NETWORK', '網路連線失敗');
    }
    return popApiError(code, message)
  }

  const { data, status } = response;
  const resCode = data.code;
  const resMessage = data.message;
  switch (status) {
    case 500:
      popApiError(resCode, '程式異常，請稍後再試。若問題重複發生，請洽詢系統供應商進行處理。');
      break;
    case 400:
      popApiError(resCode, resMessage);
      break;
    // 其他錯誤由 api 呼叫處另外處理
    default:
      console.error(resCode, resMessage);
  }
}

function popApiError (code, message) {
  if (isAlerting) return;
  console.error(code, message)

  isAlerting = true;
  const alertMsg = code ? `${code}: ${message}` : message;

  alert(alertMsg);
  isAlerting = false;
}

export default _axios;